export default __webpack_public_path__ + "static/media/icon_elight_tube_on.293d440d.png";